/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * CommandMenuGroup CSS
 */
export const styles = css`
  :host {
    box-sizing: border-box;
    display: block;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  :host([hidden]) {
    display: none !important;
  }

  .group {
    padding-bottom: var(--nile-spacing-xs, var(--ng-spacing-xs));
  }

  .group__heading {
    display: block;
    padding: var(--nile-spacing-md, var(--ng-spacing-md)) var(--nile-spacing-lg, var(--ng-spacing-lg)) var(--nile-spacing-xs, var(--ng-spacing-xs));
    font-family: var(--nile-font-family-sans-serif, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-2, var(--ng-font-size-text-xs));
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-medium));
    line-height: 1.4;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--nile-colors-dark-500, var(--ng-colors-text-quaternary-500));
  }

  .group__heading--empty {
    display: none;
  }
`;

export default [styles];
